import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Noilio - Nollywood, Reimagined',
  description = 'Discover, stream, and share the best of Nollywood in one place. Watch trending Nollywood movies, curated collections, and fan favorites.',
  image = '/Noilio Logo-white.svg',
  url = '',
  type = 'website',
  keywords = 'Nollywood, Nigerian movies, African cinema, streaming, movies, films, entertainment',
  author = 'Noilio',
  publishedTime,
  modifiedTime,
  articleAuthor,
  structuredData
}) => {
  const siteUrl = typeof window !== 'undefined' 
    ? `${window.location.protocol}//${window.location.host}`
    : 'https://noilio.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Noilio" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Article specific meta tags */}
      {type === 'article' && (
        <>
          {publishedTime && <meta property="article:published_time" content={publishedTime} />}
          {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
          {articleAuthor && <meta property="article:author" content={articleAuthor} />}
          <meta property="article:section" content="Entertainment" />
          <meta property="article:tag" content="Nollywood" />
          <meta property="article:tag" content="Movies" />
          <meta property="article:tag" content="Entertainment" />
        </>
      )}

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;


